"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    male: '남성',
    female: '여자',
};
